import React, { ReactNode } from "react";

export default function PageMargin({
  wrapperClasses,
  children,
  noBottomMargin,
}: {
  wrapperClasses?: string;
  children: ReactNode;
  noBottomMargin?: boolean;
}) {
  return (
    <div className={wrapperClasses}>
      <div
        className={`mx-2 md:mx-4 px-2 lg:mx-auto max-w-[1100px] my-0 ${
          noBottomMargin ? "mb-0" : "mb-10 md:mb-36"
        }`}
      >
        {children}
      </div>
    </div>
  );
}
